exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".launcher-form[data-v-3ed02ed0] {\n  text-align: left;\n}\n.launcher-form-remove[data-v-3ed02ed0] {\n  float: right;\n  display: flex;\n  color: var(--alert);\n  padding: var(--pad);\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n}\n.launcher-form-remove[data-v-3ed02ed0]:hover {\n  opacity: 0.5;\n}\n.launcher-form-remove[data-v-3ed02ed0]:focus {\n  border-color: currentColor;\n}", ""]);

// exports
